// Meta's WhatsApp Business display name for the account that sends
// OTPs and alerts. Must differ from the product brand ("WallaWhats")
// because Meta won't approve names containing "Whats". Surfaced in
// WhatsAppSenderHint so users know which conversation to look for
// before they receive their first message.
export const WHATSAPP_SENDER_NAME = 'BWS Notifications';
